import { render, staticRenderFns } from "./videoTutor.vue?vue&type=template&id=980cb040&scoped=true"
import script from "./videoTutor.vue?vue&type=script&lang=js"
export * from "./videoTutor.vue?vue&type=script&lang=js"
import style0 from "./videoTutor.vue?vue&type=style&index=0&id=980cb040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980cb040",
  null
  
)

export default component.exports